import { jsx as _jsx } from "react/jsx-runtime";
import { useFrame, useThree } from '@react-three/fiber';
import * as Sentry from '@sentry/react';
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IComponentType } from '../../r3f-components/component-data-structure';
import { screenRelativeCameraNeedsUpdate, updateScreenRelativeCameraProperties } from '../../r3f-components/utils/screen-relative';
import AnchorGroups from './AnchorGroups/AnchorGroups';
export let screenRelativeScene;
export let screenRelativeRenderer;
const ScreenRelativeContent = () => {
    const screenRelativeScaleType = useSelector((state) => state.contentReducer.contentDoc.screenRelativeScaleType) ?? 'height-relative';
    const activeSceneAnchorGroupCount = useSelector((state) => {
        const componentsById = state.contentReducer.contentDoc.componentsById;
        const activeSceneId = state.userReducer.activeSceneId;
        if (!activeSceneId)
            return;
        const screenContent = componentsById[componentsById[activeSceneId].children.filter((id) => {
            const component = componentsById[id];
            if (!component) {
                Sentry.captureException(new Error('SR component missing in componentsById'), {
                    extra: { componentsById, sceneId: activeSceneId, componentId: id },
                });
                return false;
            }
            return componentsById[id].type === IComponentType.ScreenContent;
        })[0]];
        return screenContent.children.length;
    });
    // ensure that anchor groups are on the canvas edges
    useFrame(({ camera, size }) => {
        if (camera.type === 'OrthographicCamera' && screenRelativeCameraNeedsUpdate(camera, size, screenRelativeScaleType)) {
            updateScreenRelativeCameraProperties(camera, size, screenRelativeScaleType);
            camera.updateProjectionMatrix();
            // https://github.com/pmndrs/react-three-fiber/issues/178
            // Update matrix world since the renderer is a frame late
            camera.updateMatrixWorld();
        }
    });
    const { scene, gl } = useThree();
    useEffect(() => {
        screenRelativeScene = scene;
        screenRelativeRenderer = gl;
    }, [activeSceneAnchorGroupCount]);
    return _jsx(AnchorGroups, {});
};
export default memo(ScreenRelativeContent);
